import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/integration-systems/integration-bar-dropdown/integration-bar-dropdown.js';
      

      export interface Props {
     showHomeButton?: boolean;
     homeButtonActivated?: boolean;
     showClock?: boolean;
     showNotificationButton?: boolean;
     notificationButtonActivated?: boolean;
     notificationCount?: number;
     showNotificationCount?: boolean;
     showUserButton?: boolean;
     userButtonActivated?: boolean;
     showDimmingButton?: boolean;
     dimmingButtonActivated?: boolean;
     showSystemButton?: boolean;
     systemButtonActivated?: boolean;
     nStatusFields?: number
   }

      
  
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcIntegrationBarDropdown',
  props: {
    showHomeButton: { type: Boolean },
    homeButtonActivated: { type: Boolean },
    showClock: { type: Boolean },
    showNotificationButton: { type: Boolean },
    notificationButtonActivated: { type: Boolean },
    notificationCount: {},
    showNotificationCount: { type: Boolean },
    showUserButton: { type: Boolean },
    userButtonActivated: { type: Boolean },
    showDimmingButton: { type: Boolean },
    dimmingButtonActivated: { type: Boolean },
    showSystemButton: { type: Boolean },
    systemButtonActivated: { type: Boolean },
    nStatusFields: {}
  },
  emits: ["home-button-clicked", "dimming-button-clicked", "notification-button-clicked", "user-button-clicked", "system-button-clicked"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onHomeButtonClicked: (event: CustomEvent<unknown>) => emit('home-button-clicked', event as CustomEvent<unknown>),
onDimmingButtonClicked: (event: CustomEvent<unknown>) => emit('dimming-button-clicked', event as CustomEvent<unknown>),
onNotificationButtonClicked: (event: CustomEvent<unknown>) => emit('notification-button-clicked', event as CustomEvent<unknown>),
onUserButtonClicked: (event: CustomEvent<unknown>) => emit('user-button-clicked', event as CustomEvent<unknown>),
onSystemButtonClicked: (event: CustomEvent<unknown>) => emit('system-button-clicked', event as CustomEvent<unknown>)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-integration-bar-dropdown',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})